import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "header-schedule-bus-detail" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "detail-category flex-1 px-1 md:px-3" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "break-words color-blue-grey-darken-1 font-semibold" }
const _hoisted_6 = { class: "flex mt-2 items-center justify-between" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "pr-2 md:pr-4 flex items-center" }
const _hoisted_9 = {
  class: "rounded-md background-green-lighten-5 py-1 px-3",
  style: {"border":"1px solid #43A047"}
}
const _hoisted_10 = { class: "color-green-darken-1 text-xs sm:text-sm" }
const _hoisted_11 = { class: "pr-2 md:pr-4 flex items-center" }
const _hoisted_12 = {
  class: "rounded-md background-grey-lighten-5 py-1 px-3",
  style: {"border":"1px solid #546E7A"}
}
const _hoisted_13 = { class: "color-blue-grey-darken-1 text-xs sm:text-sm" }
const _hoisted_14 = {
  key: 0,
  class: "pr-2 md:pr-4 flex items-center"
}
const _hoisted_15 = { class: "text-base md:text-lg color-primary" }
const _hoisted_16 = { class: "px-3 md:px-6" }
const _hoisted_17 = { class: "flex mb-4 sm:mb-5 w-full justify-end" }
const _hoisted_18 = { class: "mr-5" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "color-blue-grey-darken-1 text-xs sm:text-sm" }
const _hoisted_21 = {
  key: 0,
  class: "flex justify-between items-center w-full chip-red mb-4 p-5"
}
const _hoisted_22 = {
  class: "flex items-center",
  style: {"color":"#F44336"}
}
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "pi pi-exclamation-triangle mr-4" }, null, -1)
const _hoisted_24 = { style: {"color":"#F44336"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Masalah : ")
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { style: {"color":"#FFFFFF"} }, "Detail Masalah", -1)
const _hoisted_27 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_28 = { class: "flex justify-between items-center w-full chip-red mb-4 p-5" }
const _hoisted_29 = {
  class: "flex items-center",
  style: {"color":"#F44336"}
}
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "pi pi-exclamation-triangle mr-4" }, null, -1)
const _hoisted_31 = { style: {"color":"#F44336"} }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Masalah : ")
const _hoisted_33 = { class: "font-medium py-3" }
const _hoisted_34 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_35 = { class: "p-inputgroup w-32" }
const _hoisted_36 = { class: "" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", {
  for: "idJam",
  class: "block font-bold"
}, "Tambahkan Jam", -1)
const _hoisted_38 = {
  key: 0,
  class: "p-error"
}
const _hoisted_39 = {
  key: 2,
  class: "p-error"
}
const _hoisted_40 = {
  key: 3,
  class: "mt-2  "
}
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { class: "color-primary text-justify" }, "Penambahan jam pada jadwal mengakibatkan seluruh jam keberangkatan dan ketibaan pada rute mengalami perubahan.", -1)
const _hoisted_42 = { class: "flex justify-end items-center mt-10" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Batalkan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Card = _resolveComponent("Card")
  const _component_Button = _resolveComponent("Button")
  const _component_ScheduleBusForm = _resolveComponent("ScheduleBusForm")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, {
      class: ["card-item-category mb-4", !_ctx.dataSource.IsActive ? 'background-white-darken-1': '']
    }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("h5", _hoisted_4, _toDisplayString(_ctx.dataSource.KodeJadwal), 1),
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.moment(_ctx.dataSource.TanggalAktif).format('DD MMMM YYYY')), 1),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("p", _hoisted_10, _toDisplayString(`RIT ${_ctx.dataSource.Rit}`), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode("p", _hoisted_13, _toDisplayString(_ctx.dataSource.KodeBus), 1)
                  ])
                ]),
                (_ctx.dataSource.TotalPendapatan)
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      _createVNode("p", _hoisted_15, "Rp. " + _toDisplayString(_ctx.dataSource.TotalPendapatan), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_InputSwitch, {
                  class: "switch-og",
                  disabled: !_ctx.route.meta.permission.update,
                  modelValue: _ctx.dataSource.IsActive,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataSource.IsActive = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeIsActive(_ctx.dataSource)))
                }, null, 8, ["disabled", "modelValue"])
              ]),
              (_ctx.route.meta.permission.update || _ctx.route.meta.permission.write)
                ? (_openBlock(), _createBlock("i", {
                    key: 0,
                    class: "pi pi-ellipsis-h text-xl cursor-pointer text-black",
                    "aria:haspopup": "true",
                    "aria-controls": "overlay_panel",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDropDown($event)))
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", null, [
              _createVNode("div", _hoisted_19, [
                _createVNode("i", {
                  class: ["color-blue-grey-darken-1 mr-2", _ctx.dataSource.IsShow ? 'pi pi-eye' : 'pi pi-eye-slash']
                }, null, 2),
                _createVNode("p", _hoisted_20, _toDisplayString(_ctx.dataSource.IsShow ? 'Tampil Pada Agent' : 'Tidak Tampil Pada Agent'), 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["class"]),
    (_ctx.dataSource.Attribute1 !== null)
      ? (_openBlock(), _createBlock("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode("p", _hoisted_24, [
              _hoisted_25,
              _createVNode("b", null, _toDisplayString(_ctx.dataSource.Attribute1), 1)
            ])
          ]),
          _createVNode(_component_Button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogCatatan = true, _ctx.textCatatan='fromDetail')),
            class: "p-button-sm btn-red"
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.sliderActive,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.sliderActive = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ScheduleBusForm, {
          inAction: _ctx.inActionForm,
          data: _ctx.dataForm,
          onReloadData: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getDetailSchedule())),
          onCloseSidebar: _ctx.closeSidebar
        }, null, 8, ["inAction", "data", "onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_OverlayPanel, {
      ref: "op",
      id: "overlay_panel"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          copy: _ctx.route?.meta?.permission?.write,
          del: false,
          edit: _ctx.route?.meta?.permission?.update,
          addHour: _ctx.route?.meta?.permission?.write && _ctx.checkPermission(_ctx.PermissionEnum.AddHourSchedule),
          onCopy: _cache[7] || (_cache[7] = ($event: any) => (_ctx.copyData(_ctx.dataForm))),
          onDel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteData(_ctx.dataForm.Id))),
          onEdit: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editData(_ctx.dataForm))),
          onAddHour: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogCatatan = true, _ctx.textCatatan='fromDrop'))
        }, null, 8, ["copy", "edit", "addHour"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Dialog, {
      header: _ctx.textCatatan === 'fromDetail' ? 'Detail Masalah Jadwal' : 'Penambahan Jam Pada Jadwal',
      class: "mx-2",
      visible: _ctx.dialogCatatan,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => (_ctx.dialogCatatan = $event)),
      dismissableMask: true,
      modal: true,
      closable: true,
      breakpoints: {'960px': '75vw'},
      style: {width: '40vw'}
    }, {
      default: _withCtx(() => [
        (_ctx.dataSource.Attribute1 !== null)
          ? (_openBlock(), _createBlock("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _createVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode("p", _hoisted_31, [
                    _hoisted_32,
                    _createVNode("b", null, _toDisplayString(_ctx.dataSource.Attribute1), 1)
                  ])
                ])
              ]),
              _createVNode("p", _hoisted_33, _toDisplayString(_ctx.dataSource.Attribute1), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.textCatatan === 'fromDetail')
          ? (_openBlock(), _createBlock("div", _hoisted_34, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectProblem, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "p-field-radiobutton mr-3",
                  key: index
                }, [
                  _createVNode(_component_RadioButton, {
                    id: `radio${index}`,
                    name: "category",
                    value: item.value,
                    modelValue: _ctx.selectRadio,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectRadio = $event))
                  }, null, 8, ["id", "value", "modelValue"]),
                  _createVNode("label", {
                    for: `radio${index}`,
                    class: "ml-1"
                  }, _toDisplayString(item.title), 9, ["for"])
                ]))
              }), 128)),
              _createVNode("div", _hoisted_35, [
                (!_ctx.selectRadio)
                  ? (_openBlock(), _createBlock(_component_InputNumber, {
                      key: 0,
                      class: "input-primary rounded-lg",
                      modelValue: _ctx.totalSend,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.totalSend = $event)),
                      showButtons: "",
                      buttonLayout: "horizontal",
                      incrementButtonIcon: "pi pi-plus",
                      decrementButtonIcon: "pi pi-minus",
                      min: 0,
                      placeholder: "Jam"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_36, [
          _hoisted_37,
          _createVNode(_component_InputNumber, {
            id: "idJam",
            class: "input-primary rounded-lg mt-2 w-full inputJam",
            modelValue: _ctx.v$.totalSend.$model,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.v$.totalSend.$model = $event)),
            showButtons: "",
            buttonLayout: "horizontal",
            incrementButtonIcon: "pi pi-plus",
            decrementButtonIcon: "pi pi-minus",
            min: 0,
            placeholder: "Jam"
          }, null, 8, ["modelValue"]),
          ((_ctx.v$.totalSend.$invalid && _ctx.submitted) || _ctx.v$.totalSend.$pending.$response)
            ? (_openBlock(), _createBlock("small", _hoisted_38, _toDisplayString(_ctx.v$.totalSend.required.$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Textarea, {
          modelValue: _ctx.v$.keteranganCatatan.$model,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.v$.keteranganCatatan.$model = $event)),
          class: "mt-3 input-primary w-full rounded-lg",
          rows: "4",
          cols: "30",
          placeholder: "Beri Keterangan"
        }, null, 8, ["modelValue"]),
        ((_ctx.v$.keteranganCatatan.$invalid && _ctx.submitted) || _ctx.v$.keteranganCatatan.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_39, _toDisplayString(_ctx.v$.keteranganCatatan.required.$message), 1))
          : _createCommentVNode("", true),
        (!_ctx.selectRadio)
          ? (_openBlock(), _createBlock("div", _hoisted_40, [
              _hoisted_41
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_42, [
          _createVNode(_component_Button, {
            label: "Simpan Perubahan",
            class: "font-semibold p-button-sm btn-primary px-10 mr-2",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.tambahWaktu(!_ctx.v$.$invalid)))
          }),
          _createVNode(_component_Button, {
            class: "self-stretch btn-secondary text-black p-button-sm px-10 py-1 justify-center",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.dialogCatatan = false))
          }, {
            default: _withCtx(() => [
              _hoisted_43
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ]))
}